export default __webpack_public_path__ + "static/media/sms.ea390e51.svg";